import { render } from "./Piano.vue?vue&type=template&id=1e8a5ed8"
import script from "./Piano.vue?vue&type=script&lang=js"
export * from "./Piano.vue?vue&type=script&lang=js"

import "./Piano.vue?vue&type=style&index=0&id=1e8a5ed8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__